module.exports = __webpack_public_path__ + "img/scene_warm_white_big@2x.c67ad44a.png";